// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__JK0vz","error":"Select_error__14Ass","label":"Select_label__IOGQW","span":"Select_span__1ByqQ"};